import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { LoadingState } from '../constants/Constants'
import { FrontPageArticle, FrontPageData } from './viewmodels/FrontPageViewModel'

const initialState: FrontPageData = {
    frontPageArticles: [] as FrontPageArticle[],
    loadingState: LoadingState.Idle,
}

export const fetchFrontPage = createAsyncThunk('fetchFrontPage', async () => {
    let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/articles/' : '/api/articles/'
    const response = await axios.get(URL);
    return response.data as FrontPageArticle[];
})

const frontPageSlice = createSlice({
    name: 'frontPage',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(fetchFrontPage.pending, (state, action) => {
                state.loadingState = LoadingState.InitialLoad
            })
            builder.addCase(fetchFrontPage.fulfilled, (state, action) => {
                state.loadingState = LoadingState.Idle
                state.frontPageArticles = action.payload
            })
        }
})

export default frontPageSlice.reducer